// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const brn: CountryValidator<"KR"> = createValidator(
  "kr.brn",
  109,
);

export default brn;
export const compact = brn.compact;
export const format = brn.format;
export const validate = brn.validate;
export const generate = (): string =>
  brn.generate?.() ??
  (() => {
    throw new Error(
      "Validator kr.brn cannot generate values",
    );
  })();
